import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";
import type {
  HomeTempProductSection,
  HomeTempImageItem,
  HomeTempProductItem,
} from "~/services/model/product";

import ProductCard from "./ProductCard.vue";
import ImgCard from "./ImgCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleTemp1',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
  items: HomeTempProductSection["data"];
}



const image = computed(
  () => props.items.find((v) => v.type === "image") as HomeTempImageItem
);
const products = computed(
  () =>
    props.items.filter(
      (v) => v.type === "product"
    ) as Array<HomeTempProductItem>
);

return { __sfc: true,props, image, products, ProductCard, ImgCard }
}

})